import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';

interface HeaderOnboardProps {
  icon?: ReactNode;
  title?: ReactNode;
  text?: ReactNode;
  buttonText?: ReactNode;
  onClick?: () => void;
  variant?: 'default' | 'destructive' | 'success';
}

export default function HeaderOnboard({
  icon,
  title,
  text,
  buttonText,
  onClick,
  variant = 'default',
}: HeaderOnboardProps) {
  const navigate = useNavigate();
  const { t } = useTranslation('onboarding');

  const handleClick = onClick || (() => navigate('/onboarding'));

  const backgroundColor =
    variant === 'destructive'
      ? 'bg-red-400'
      : variant === 'success'
        ? 'bg-emerald-600'
        : 'bg-warningStrong';

  return (
    <header
      className={`${backgroundColor} text-sm gap-4 lg:min-h-12 w-full text-onColor px-4 py-2 flex justify-center items-center`}
    >
      {icon}
      <p className='max-w-[680px]'>
        {title ? (
          <strong className={text ? 'mr-1' : undefined}>{title}</strong>
        ) : null}
        {text}
      </p>
      {onClick ? (
        <Button
          onClick={handleClick}
          variant='outline'
          className='bg-transparent'
        >
          {buttonText || t('take_me')}
        </Button>
      ) : null}
    </header>
  );
}